import React, { useCallback } from "react";

import { getSourcePlatform } from "@catchoftheday/analytics";
import { Button, ButtonProps } from "@catchoftheday/cg-components";

type BuyNowButtonProps = {
  offerId: string;
  quantity: number;
  imageUrl: string;
  title: string;
  setError?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  sourceId?: string;
  sourceType?: number;
  sourcePosition?: number;
  eventId?: number;
  redirectUrl: string;
  onClick?: () => void;
  /** No toast to show for adding to cart. */
  noToast?: boolean;
  fetchPolicy?: "no-cache";
  isFormValid?: () => Promise<boolean>;
  getValues?: () => Record<string, string | number>;
} & ButtonProps;

export const BuyNowButton = ({
  offerId,
  quantity,
  imageUrl,
  title,
  setError,
  setLoading,
  children,
  sourceId,
  sourceType,
  sourcePosition,
  eventId,
  redirectUrl,
  onClick,
  noToast,
  isFormValid,
  getValues,
  ...props
}: BuyNowButtonProps) => {
  const onBuyNow = useCallback(() => {
    setLoading?.(true);

    const data: Record<string, string> = {
      eventId: eventId?.toString() ?? "",
      offerId: offerId,
      quantity: quantity.toString() ?? 1,
      sourcePlatform: getSourcePlatform(),
      sourceId: sourceId ?? "",
      sourceType: sourceType?.toString() ?? "",
      sourcePosition:
        typeof sourcePosition === "undefined" ? "" : sourcePosition.toString(),
    };

    location.assign(redirectUrl + "?" + new URLSearchParams(data).toString());
  }, [
    redirectUrl,
    sourceId,
    sourceType,
    sourcePosition,
    offerId,
    eventId,
    setLoading,
    quantity,
  ]);

  return (
    <Button
      variant={props.variant ?? "plain"}
      sizeVariant="sm"
      p={0}
      onClick={onBuyNow}
      aria-label="Buy Now"
      color="secondary"
      textTransform="initial"
      fontSize={{ xs: "xs", md: "base" }}
      fontWeight="normal"
      underlineOnHover
      {...props}
    >
      {children}
    </Button>
  );
};
